export default __webpack_public_path__ + "static/media/Logo_beta.56805db5.png";